import { useSelector } from "react-redux"
import Squares from "../../../components/04_common/03_squares/Squares"
import textsImage from "./01_images/texts.jpg"
import signsImage from "./01_images/signs.jpg"
import { reading } from "../../../i18n/07_reading"


const ReadingSquares = () => {
  const lang = useSelector(state => state.lang.lang)
  const t = reading[lang]
  const images = [ textsImage, signsImage ]

  const items = t.squares.map((value, index) => ({
    src: images[index],
    title: value.title,
    path: value.path
  }))

  return (
    <Squares items={items}/>
  )
}

export default ReadingSquares